import { LoaderCircle } from 'lucide-react'

export function Spinner({ size = 20, className = 'text-muted' }: { size?: number; className?: string }) {
  return <LoaderCircle size={size} className={`animate-spin ${className}`} aria-label="Загрузка" />
}
